export const LogoMark = ({ className = "h-9" }) => (
    <img src="/logo.png" alt="The Market Lugano" className={`${className} w-auto`} />
);
